import en from "./en";
import hi from "./hi";
import gu from "./gu";
import mr from "./mr";

export const translations = { en, hi, gu, mr };

export const languages = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "gu", label: "ગુજરાતી" },
  { code: "mr", label: "मराठी" },
];
